
export default class Task {

  constructor(timeout = 0) {
    this._resolve = null;
    this._throw = null;
    this._promise = new Promise((resolve, reject) => { this._resolve = resolve; this._throw = reject; });
    this._completed = false;
    if (timeout !== 0) {
      setTimeout(() => this.complete(), timeout);
    }
  }

  get completed() {
    return this._completed;
  }

  complete(value) {
    if (!this._completed) {
      this._completed = true;
      this._resolve(value);
    }
  }

  async wait() {
    return await this._promise;
  }

  throw(exception) {
    this._completed = true;
    this._throw(exception);
  }

  static Delay(time = 1) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  static DelayTask(time = 1) {
    return new Task(time);
  }

}